function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCableShort = function SvgIconCableShort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 200.66 394.18",
    focusable: "false",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    id: "Imagery",
    d: "M160.66 76.54v227.78c0 15.12-5.53 29.31-15.17 38.93-5 4.99-13.34 10.93-24.7 10.93h-.07c-21.71-.05-40.04-23.01-40.04-50.14v-90.47h-.02v-53.19c23.42-7.97 40.23-29.36 40.23-54.46V39.15h-18.36V0h-30v39.15H48.38V0h-30v39.15H0v66.77c0 25.24 17.01 46.73 40.64 54.59v86.53h.02v57c0 49.6 35.87 90.04 79.95 90.14h.16c19.53 0 38.34-8.03 52.96-22.62 17.11-17.07 26.92-41.58 26.92-67.25V65.82l-40 10.72Zm-130.6 29.38V69.15h60.88v36.77c0 15.32-13.65 27.79-30.44 27.79s-30.44-12.47-30.44-27.79",
    style: {
      fill: "#0a9828",
      strokeWidth: 0
    }
  }));
};
export default SvgIconCableShort;